<template>
    <div class=" pb-6 px-5 treasurehunt-cards">
        <div class="notification is-eduloc-green mb-0 is-radiusless mt-4 game-active" v-if="isSessionActive && !$store.getters.isAnonymous">
            <figure class="image is-32x32 is-inline-block">
                <img src="@/assets/icons/ON-04.svg">
            </figure>
            <span class="is-size-4">
                {{$t('game_session_started')}}
            </span>
            <!--<p class="html-message" v-html="$t('game_session_started_warning')" />-->
            <p class="html-message">{{$t('game_session_started_warning')}}</p>
        </div>

        <div class="columns is-mobile">

            <div class="column has-text-white pt-3 mt-6">
                <div v-if="items.length">
                    <project-treasurehunt-card
                        v-for="(object, _id, index) in path"
                        :key="_id"
                        :id="object._id"
                        :object="object"
                        :model="contentModel"
                        :showObjectButtons="index == Object.keys(path).length - 1"
                        :index="index+1"
                        :selected-object="selectedObject"
                        :canCreateOrEditObjects="canCreateOrEditObjects"
                        :editionEnabled="editionEnabled"
                        :creationEnabled="creationEnabled"
                        :hideButtons="hideButtons"
                        :canCreateObject="canCreateObject"
                        class="lb-treasurehunt-object"
                        @add="insertObject({ ...$event, ...{ object } })"
                        @closeOthers="closeOthers"
                        @edit-object="editObject"
                        @view="viewObject"
                        @remove="removeObject"
                        @hover="hoverIn"
                        @leave="hoverOut"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProjectTreasurehuntCard from '@/components/ProjectTreasurehuntCard';
import { getShortestPaths } from '@xstate/graph';
import { createMachine } from 'xstate';
import _ from 'underscore';
import { TREASUREHUNT_OBJECT_TYPES, TREASUREHUNT_DEFAULT_TRIGGER } from '@/lib/constants';

export default {
    components: {
        ProjectTreasurehuntCard,
    },
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        selectedObject: {
            type: String,
            default: undefined,
        },
        canCreateOrEditObjects: {
            type: Boolean,
            default: false,
        },
        editionEnabled: {
            type: Boolean,
            default: false,
        },
        creationEnabled: {
            type: Boolean,
            default: false,
        },
        isSessionActive: {
            type: Boolean,
            default: false,
        },
        canCreateObject: { type: Boolean, default: false },
    },
    data() {
        return {
            activeDraft: {},
            selectedTrigger: undefined,
            selectedModel: undefined,
            originalItem: {},
            originalGoal: {},
            editMode: false,
            creationMode: false,
            hideButtons: false,
        };
    },
    computed: {
        contentModel() {
            if (!this.selectedModel) {
                return this.$store.getters[`objectModel`];
            }
            // console.log('finding', this.selectedModel + 'Model');
            return this.$store.getters[`${this.selectedModel}Model`];
        },
        draftDefaults() {
            // console.log('draftDefaults', this.contentModel);
            return {
                _id: 'draft',
                type: this.contentModel.type,
                order: this.items.length,
                triggers: { [TREASUREHUNT_DEFAULT_TRIGGER]: '' },
                owner: this.$store.getters.user.owner,
            };
        },
        lastItem() {
            return this.items.length ? this.path[_.last(this.shortPath)] : null;
        },
        states() {
            const _states = {};
            this.items.forEach((item) => {
                _states[item._id] = {
                    on: item.triggers,
                };
                if (!item.triggers) {
                    _states[item._id].type = 'final';
                }
            });
            return _states;
        },
        shortPath() {
            return _.map(getShortestPaths(this.machine), (node) => {
                return node.state.value;
            });
        },
        path() {
            // console.log('in path', path);
            let path = {};
            _.each(this.shortPath, (_id) => {
                path[_id] = this.findModel({ _id });
            });
            // console.log('in path', path);
            return path;
        },
        
        machine() {
            const initialItem = _.sortBy(this.items, (item) => {
                return item.order;
            })[0];
            return createMachine({
                id: 'machine',
                initial: initialItem._id,
                states: this.states,
            });
        },
    },
    methods: {
        insertObject({ object, trigger, type }) {
            if (!this.editMode && !this.creationMode) {
                this.selectedModel = type;
                this.enableCreation();
                if(object){
                    let previousObject = JSON.parse(JSON.stringify(object));
                    this.selectedTrigger = _.keys(previousObject.triggers)[0];
                    let objectTriggerValue = '';
                    if (previousObject.triggers[this.selectedTrigger].length) {
                        objectTriggerValue = JSON.parse(
                            JSON.stringify(
                                previousObject.triggers[this.selectedTrigger]
                            )
                        );
                    }
                    this.activeDraft.order = previousObject.order + 1;
                    const values = _.values(previousObject.triggers);
                    this.activeDraft.triggers = {
                        [TREASUREHUNT_DEFAULT_TRIGGER]: objectTriggerValue,
                    };

                    let newObject=this.activeDraft;
                    newObject.owner = this.$store.getters.user;
                    
                    this.$emit('add',{previousObject,newObject,type});
                } 
            }
        },
        closeOthers() {
            // console.log("hidding")
            this.hideButtons=!this.hideButtons;
        },
        findModel(params) {
            return _.findWhere(this.items, params);
        },
        enableCreation() {
            // console.log('enableCreation');
            this.activeDraft = this.draftDefaults;
            // console.log('enableCreation', this.activeDraft);
            this.$store.dispatch('Project/enableCreation');
        },
        openObject(e){
            //console.log("opening object",e)
            this.$emit("open-object",e)
        },
        hoverIn(e){
            //console.log("cards",e)
            this.$emit('hover',e);
        },
        hoverOut(e){
            this.$emit('leave',e);
        },
        editObject(e){
            //console.log("editing object",e)
            this.$emit("edit-object",e)
        },
        viewObject(e){
            let initialPreviewObject = e._id;
            let pathPreview =JSON.parse(
                JSON.stringify(this.path)
            );
            this.$emit('view',{initialPreviewObject,pathPreview});
        },
        removeObject(e){
            this.$emit('remove',e);
        },
    },
    mounted() {},
};
</script>

<style scoped>
@import '../assets/css/tippyeduloc.css';
.lb-treasurehunt-content {
    min-height: calc(100vh - 9rem);
}
.helpIcon{
    position: absolute;
    top:0;
    right: 5px;
}
.lb-th-action-button {
    margin: 0.2rem;
    width: 12rem;
}
.game-active span{
    line-height: 30px;
    vertical-align: top;
    padding-left: 0.5rem;
    padding-right: 2rem;
}
.html-message{
    font-family: var(--secondary-font);
}
.treasurehunt-cards{
    min-height: calc(100vh - 50px);
}

</style>
